import { useEffect, useState } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { PaymentElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import { Grid, Box, Modal, TextField, Typography, Button, FormControl, InputLabel, Select, MenuItem, IconButton, ListItemIcon, ListItemText, Input, FormControlLabel, Radio, RadioGroup, FormLabel } from '@mui/material';
import Apiconnection from "../../utils/Apiconnection";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";


const PaymentForm = ({ payload, clientsecret, stripeorderid, totalAmount, onCancel }) => {
    const stripe = useStripe();
    const elements = useElements();
    
    console.log('PaymentForm - payload:', payload);
    console.log('PaymentForm - stripe status:', !!stripe);
    console.log('PaymentForm - elements status:', !!elements);
    console.log('PaymentForm - clientsecret:', clientsecret);

    const userId = JSON.parse(localStorage.getItem('userInfo'));

    const { email, password, customerId, firstName, lastName, phone, licensePlateNumber, startDate, endDate } = payload;
    console.log('Payment-form_customerId',customerId)
    const [customerName, setCustomerName] = useState((payload?.firstName || payload?.firstname) + ' ' + (payload?.lastName || payload?.lastname));
    const [Firstname, setFirstname] = useState(payload?.firstName || payload?.firstname);
    const [Lastname, setLastname] = useState(payload?.lastName || payload?.lastname);
    const [vendorId, setVendorId] = useState(payload?.vendorId);
    // const [email2, setEmail2] = useState(payload?.email);
    const [vechiletypeId, setvechiletypeId] = useState(payload?.vehicleTypeId);
    const [ReservationId, setReservationId] = useState(payload?.reservationId);
    const [cnfReservationId, setcnfReservationId] = useState(payload?.reservationId);
    const [bookingPlatform, setbookingPlatform] = useState(payload?.bookingPlatform);
    const [logInType, setlogInType] = useState(payload?.logInType);
    const [slotId, setslotId] = useState(payload?.slotId);
    const [dialCode, setdialCode] = useState(payload?.dialCode);
    const [fromDate, setfromDate] = useState(payload?.fromDate);
    const [selectedCheckInTime, setselectedCheckInTime] = useState(payload?.selectedCheckInTime);
    const [toDate, settoDate] = useState(payload?.toDate);
    const [selectedCheckOutTime, setselectedCheckOutTime] = useState(payload?.selectedCheckOutTime);
    const [passengerCount, setpassengerCount] = useState(payload?.passengerCount);
    // const [customerId, setcustomerId] = useState(payload?.customerId);
    const [actualvehicleTypeId, setactualvehicleTypeId] = useState(payload?.actualvehicleTypeId);
    const [actualFromDate, setactualFromDate] = useState(payload?.actualFromDate);
    const [actualCheckInTime, setactualCheckInTime] = useState(payload?.actualCheckInTime);
    const [actualToDate, setactualToDate] = useState(payload?.actualToDate);
    const [actualCheckOutTime, setactualCheckOutTime] = useState(payload?.actualCheckOutTime);
    const [dailyParkingRate, setdailyParkingRate] = useState(payload?.dailyParkingRate);
    const [onSiteChargeForVendor, setonSiteChargeForVendor] = useState(payload?.onSiteChargeForVendor);

    const [mobileNumber, setMobileNumber] = useState(payload?.phone);
    const [plateNumber, setPlateNumber] = useState(payload?.plateNumber);
    const [confirmPlateNumber, setConfirmPlateNumber] = useState(payload?.plateNumber);
    const [numPassengers, setNumPassengers] = useState(payload?.passengerCount);
    const [carType, setCarType] = useState(payload?.carType || '');
    const [slotName, setSlotName] = useState(payload?.slotName || '');
    const [startDateTime, setStartDateTime] = useState(payload?.fromDate + 'T' + payload?.selectedCheckInTime);
    const [endDateTime, setEndDateTime] = useState(payload?.toDate + 'T' + payload?.selectedCheckOutTime);
    const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
    const [invoiceCreate, setInvoiceCreate] = useState({});
    const [bookingRequestDetail, setBookingRequestDetail] = useState({});
    const [vehicleTypeName, setVehicleTypeName] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [stripePkey, setstripePkey] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    // const [clientsecret, setclientsecret] = useState(null);
    const [paymentres, setpaymentres] = useState('');
    const [stripePromise, setStripePromise] = useState(null);
    const [options, setOptions] = useState('pi_3QQMswCvBhAhbwyk0pPWwQmI_secret_55RFUiazZCR7YLbaYV0eSeQP6');
    const [openModal, setOpenModal] = useState(false);
    const [email2, setEmail2] = useState(payload?.email);
    const [fname, setfname] = useState(payload?.firstName || payload?.firstname);
    const [lname, setlname] = useState(payload?.lastName || payload?.lastname);
    const [mob, setmob] = useState(payload?.phone);
    const [custId, setcustId] = useState(payload?.customerId);
    console.log('custId',custId)
    // const [startDate, setstartDate] = useState(null)
    // const [endDate, setendDate] = useState(null)
    // const [licensePlateNumber, setLicensePlateNumber] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isPaymentReady, setIsPaymentReady] = useState(false);
    // const { customerId } = location.state || {};
    const [mobileNumber2, setMobileNumber2] = useState(payload?.password);
    console.log('mobileNumber',mob,mobileNumber2);
    console.log('email',email,email2);

    const navigate = useNavigate();

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        if (!stripe) {
            return
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        )

        console.log('clientSecret', clientSecret)

        if (!clientSecret) {
            return
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    console.log("payment success")

                    break;
                case "processing":
                    console.log("Your payment is processing")
                    break;

                case "requires_payment_method":
                    console.log("Your payment was not successfully, please try again")

                    break;

                default:

                    console.log("something went wrong")
                    break;
            }
        })


    }, [stripe, clientsecret]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = {};

        if (!stripe || !elements) {
            toast.error('Stripe.js has not loaded yet.');
            return;
        }

        setIsProcessing(true);

        const currentUrl = new URL(window.location.href);
        const baseUrl = currentUrl.origin + currentUrl.pathname;

        // Confirm the payment
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${baseUrl}?#/booking-details`,
            },
            redirect: "if_required",
        });

        console.log('Payment confirmation result:', result);

        if (result.error) {
            console.error(result.error);
            toast.error(result.error.message || 'Payment failed.');
            setErrorMessage(result.error.message);
            setIsProcessing(false);
            return; // Stop execution on error!
        }

        const verifyPaymentPayload = {
            stripeOrderId: stripeorderid,
            amount: totalAmount,
            currency: "USD",
            userId: userId?.id,
            firstName: customerId ? firstName : fname,
            lastName: customerId ? lastName : lname,
        };

        const verifyPaymentResponse = await Apiconnection.post('verify-payment-via-stripe', verifyPaymentPayload);
        const transactionId = verifyPaymentResponse.data.data.id;
        const transactioncreatedId = verifyPaymentResponse.data.data.transactionCreatedId;

        let payload = {
            parkingGroundId: "1",
            bookingPlatform: "customerPanel",
            logInType: customerId ? "Customer" : "Guest",
            customerId: customerId ? customerId : custId,
            vehicleTypeId: "72",
            dialCode: dialCode,
            slotId: slotId,
            firstName: customerId ? firstName : fname,
            lastName: customerId ? lastName : lname,
            email: customerId ? email : email2,
            // phone: customerId ? phone : mobileNumber2,
            phone: customerId ? phone : (custId ? mobileNumber2 : phone), // Updated line for phone
            plateNumber: licensePlateNumber,
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            selectedCheckInTime: moment(startDateTime).format(('HH:mm:ss')),
            toDate: moment(toDate).format('YYYY-MM-DD'),
            selectedCheckOutTime: moment(endDateTime).format(('HH:mm:ss')),
            passengerCount: "4",
            transactionHistoryId: transactionId,
            transactionCreatedId: transactioncreatedId
        };

        try {
            const response = await Apiconnection.post('booking-request-create', payload);
            if (response?.data?.status) {
                const bookingRequestId = response.data.data.id;
                // Extract values from the booking response
                const bookingRequestcheckinDate = response.data.data.fromDate; // from booking-request-create response
                const bookingRequeststartTime = response.data.data.selectedCheckInTime; // from booking-request-create response
                const bookingRequestcheckoutDate = response.data.data.toDate; // from booking-request-create response
                const bookingRequestendTime = response.data.data.selectedCheckOutTime; // from booking-request-create response

                // Prepare the payload for calculate-booking-charges-before-booking API
                const calculateBookingChargesPayload = {
                    onSiteChargeForVendor: "0",
                    parkingGroundId: "1",
                    platform: "CustomerPanel",
                    bookingRequestId,
                    vehicleTypeId: "72",
                    passengerCount: "4",
                    checkinDate: bookingRequestcheckinDate, // Use fromDate from booking response
                    startTime: bookingRequeststartTime, // Use selectedCheckInTime from booking response
                    checkoutDate: bookingRequestcheckoutDate, // Use toDate from booking response
                    endTime: bookingRequestendTime, // Use selectedCheckOutTime from booking response
                };
                const calculateBookingChargesResponse = await Apiconnection.post('calculate-booking-charges-before-booking', calculateBookingChargesPayload);
                if (calculateBookingChargesResponse?.data?.status) {
                    toast.success('Booked Successfully!');
                    const bookingDetails = {
                        invoiceCreate: calculateBookingChargesResponse.data.data?.invoiceCreate,
                        bookingRequestDetail: calculateBookingChargesResponse?.data?.data?.bookingRequestDetail,
                        customerid: payload?.customerId
                    };
                    navigate('/booking-details', { state: bookingDetails });
                    console.log("bookingDetails", bookingDetails)
                } else {
                    toast.error('Failed to calculate booking charges!');
                }
            } else {
                toast.error('Failed to create booking!');
            }
        } catch (error) {
            console.error('Error adding vehicle data:', error);
            toast.error('Failed to create booking!');
        } finally {
            setIsProcessing(false);
        }
    };



    return (
        <form onSubmit={handleSubmit} style={{ minHeight: '200px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box
                data-testid="payment-form-scroll-region"
                sx={{ flex: 1, minHeight: 0, overflowY: 'auto', pr: 1 }}
            >
                {!isPaymentReady && (
                    <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
                        Loading payment details...
                    </div>
                )}
                <div style={{ display: isPaymentReady ? 'block' : 'none' }}>
                    <PaymentElement onReady={() => setIsPaymentReady(true)} />
                </div>
            </Box>
            <Box display="flex" justifyContent="flex-end" mt={4} gap={2}>
                <button 
                    type="button"
                    onClick={onCancel} 
                    disabled={isProcessing}
                    style={{ padding: '12px 30px', backgroundColor: '#f5f5f5', color: '#666', border: 'none', borderRadius: '100px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.3s' }}
                >
                    Cancel
                </button>
                <button 
                    type="submit" 
                    disabled={isProcessing || !stripe || !isPaymentReady}
                    style={{ padding: '12px 35px', backgroundColor: '#004777', color: 'white', border: 'none', borderRadius: '100px', fontSize: '15px', fontWeight: '700', cursor: (isProcessing || !stripe || !isPaymentReady) ? 'not-allowed' : 'pointer', transition: 'all 0.3s', boxShadow: '0 8px 20px rgba(0, 71, 119, 0.2)' }}
                >
                    {isProcessing ? 'Processing...' : 'Confirm Payment'}
                </button>
            </Box>
            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
        </form>
    )
}

export default PaymentForm
